module.exports = __webpack_public_path__ + "static/img/rules-bg.46e42e6d.png";